export const productBestListSelector = store => store.productRandom.best;
export const isLoadingProductBestSelector = store => store.productRandom.isLoading;
export const errorProductBest = store => store.productRandom.error;
